import React, { useState, useContext } from "react";
import PropTypes from "prop-types";
import { useMsal } from "@azure/msal-react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Typography, Box } from "@mui/material";
import { formatEmpty } from "../../../../utils/formatHelpers";
import { nullCheck } from "../../../../utils/dataHelpers";
import StyledTooltip from "../../../StyledTooltip/StyledTooltip";
import StyledPopover from "../../../StyledPopover/StyledPopover";
import UserAutocomplete from "../../../Inputs/UserAutocomplete/UserAutocomplete";
import { CarrierService } from "../../../../services/CarrierService";
import { AlertContext } from "../../../Dashboard/Dashboard";

export default function CarrierRepNameCell({ cell, row, column, updateData }) {
  const { instance } = useMsal();
  const { warning } = useContext(AlertContext);
  const originPoint = nullCheck(column, false, "originPoint");
  const active = nullCheck(cell, false, "row", "original", "activeRow");
  const movementId = nullCheck(cell, null, "row", "original", "movementId");
  const repName = nullCheck(cell, null, "row", "original", "dispatcherUserName");
  const [isLoading, setIsLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const pid = open ? "carrier-rep-select-popover" : undefined;

  const handleUpdateDispatcher = (user) => {
    if (!user || cell.value === user.userIdMcld) return;

    const payload = {
      movementId: movementId,
      dispatcherId: user.userIdMcld
    };

    setIsLoading(true);
    CarrierService.UpdateDispatch(instance, payload).then(() => {
      updateData(row.index, column.id, user.userIdMcld);
      setAnchorEl(null);
      setIsLoading(false);
    }).catch(error => {
      setIsLoading(false);
      console.error(error);
      warning(error);
    });
  };

  return (
    <Box
      sx={{ display: "flex", alignItems: "center" }}
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <StyledTooltip title={repName || cell.value}>
        <Box
          onClick={(e) => originPoint === "load-board" && setAnchorEl(e.currentTarget)}
          sx={{ display: "flex", alignItems: "center", "&:hover": { cursor: "pointer" } }}
        >
          {originPoint === "load-board" &&
            <KeyboardArrowDownIcon
              sx={{ color: "black_solid.50", fontSize: "20px" }}
            />
          }
          <Typography
            variant="body1"
            sx={{
              color: active ? "white_opacity.100" : "black_solid.80",
            }}
          >
            {formatEmpty(cell.value)}
          </Typography>
        </Box>
      </StyledTooltip>
      <StyledPopover
        id={pid}
        open={open}
        anchorEl={anchorEl}
        title="Assign Carrier Rep"
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
      >
        <Box>
          <UserAutocomplete
            label="Select a Rep for this Load"
            updateSelectedUser={handleUpdateDispatcher}
            size="small"
            width="200px"
            disabled={isLoading}
            enableUserIdMcld
          />
        </Box>
      </StyledPopover>
    </Box>
  );
}

CarrierRepNameCell.propTypes = {
  cell: PropTypes.object,
  row: PropTypes.object,
  column: PropTypes.object,
  updateData: PropTypes.func
};